"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MapMarkersLegendComponent = /** @class */ (function () {
    function MapMarkersLegendComponent() {
    }
    return MapMarkersLegendComponent;
}());
exports.MapMarkersLegendComponent = MapMarkersLegendComponent;
